import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState } from "react";

interface InputEmailLoginProps {
  label: string;
  handleChange?: any;
  name?: string;
  value?: string;
  disabled?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
}

const InputEmailLogin = ({
  label,
  handleChange,
  name,
  value,
  disabled,
  onKeyDown,
}: InputEmailLoginProps) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#33BBED",
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            width: "100%",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <TextField
        type="email"
        onChange={(e: any) => handleChange(e.target.value, name)}
        name={name}
        value={value}
        id="demo-helper-text-misaligned"
        label={label}
        disabled={disabled}
        onKeyDown={onKeyDown}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "5px", 
            backgroundColor: "#FFF",
          },
        }}
      />
    </ThemeProvider>
  );
};

export default InputEmailLogin;
